export default "__VITE_ASSET__6tui81_j__"